export enum SessionStorageKeys {
  WebsocketSubscriberId = 'WebsocketSubscriberId',
  ServerVersion = 'ServerVersion',
}
